module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"to.refresh":"ลองอีกรอบ","to.home":"กลับหน้าแรก","to.login":"Login"}}')
  delete Component.options._Ctor
}
